<template>
  <div class="other-products">
      <div class="container-bar line-wrapper">
      

      </div>
      <div class="container-bar ttl-wrapper">
          
          <div class="ttl">
              <h2 class="f-21">{{ $fn.tr('სხვა პროდუქტები') }}</h2>
          </div>
          <div class="all-products">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.204" height="19.069" viewBox="0 0 26.204 19.069">
  <g id="Group_104" data-name="Group 104" transform="translate(25.293 -3.205)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.818,53.818,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

<router-link :to="getShopLink" class="f-21">{{ $fn.tr('ყველა პროდუქტი') }}</router-link>
          </div>
      </div>
      <div class="container-bar other-products-wrapper">
               <router-link :to="$store.getters['main/getSingleUrl'](products)" class="products-list-box" v-for="(products, index) in productsList" :key="index">
               
                
                <div v-html="products.svg" class="shop-sticker"></div>
            <div class="products-list-box-img-wrapper">
              <!-- <picture>
                <source media="(max-width:767px)" :srcset="_.get(products, 'images.0.devices.mobile')">
                <source media="(max-width:1023px)" :srcset="_.get(products, 'images.0.devices.tablet')">
                <img :src="_.get(products, 'images.0.devices.desktop')" :alt="_.get(products, 'images.0.title')">
              </picture> -->

                <img :src="_.get(products, 'images.0.devices.desktop')" :alt="_.get(products, 'images.0.title')">
            </div>
          
           <div class="products-list-box-text-block">
            
                 <span class="f-21 bold-italic products-desc">{{ _.get(products, 'title') }}</span>
                    <span class="f-21 bold-italic products-price">{{ _.get(products, 'price') }} ₾</span>
           </div>
   
                
              </router-link>
      </div>
  </div>
</template>

<script>

export default {
  props: ["contentData"],
computed: {
    productsList(){
        let products = null;
      if(this.$store.state.main.current_content_request_status === 'done'){
        products = _.get(this.contentData, 'data.list');
            products = products.filter(ne => ne.id !== this.$store.state.main.current_content.primary.data.list[0].id);
            products = products.splice(0, 3);
            return products;
      } 
    },
    
      getShopLink(){
        let _m = this.$store.state.main.indx.menus;
      let dup = [..._m]
      dup = dup.filter(m => m.configs.includes("shop"))
      return dup[0].full_url;
      }
},
methods: {
 
}
}
</script>

<style>

</style>